import { Grid } from '@material-ui/core'
import React from 'react'
import { ButtonHLPure, HeaderHLPure } from '../../../pures'
import { useTranslation } from 'react-i18next';

function SummaryView(props) {
  const { user, onSubmitStep, dataBusiness, type = 'onboarding' } = props; // onboarding-user
  const { t: tCommon } = useTranslation('common');

  return (
    <>
      <Grid container className='summaryView' spacing={3}>
        {
          type === 'onboarding' ?
            <>
              <Grid item xs={12}>
                <HeaderHLPure title={tCommon('titleSummary')} />
              </Grid>

              <Grid item xs={12}>
                <div className='summaryView-success'>
                  <span class="k-icon k-font-icon k-i-check"></span>
                  <p>{tCommon('descriptionSummary')}</p>
                </div>
              </Grid>

              {
                /* <Grid item xs={12}>
                    <h2>PLAN EMPRESARIAL</h2>
                 </Grid> */
              }

              <Grid item xs={12} md={6}>
                <p><strong>{tCommon('summaryName')}</strong><br />{user?.firstName} {user?.firstLastName} {user?.secondLastName}</p>
                <p><strong>{tCommon('summaryContact')}</strong><br />{user?.email}</p>
                {
                  user?.phoneNumber && <p><strong>{tCommon('phoneNumber')}</strong><br />{user?.phoneNumber}</p>
                }
              </Grid>

              <Grid item xs={12} md={6}>
                <p><strong>{tCommon('companyName')}</strong><br />{dataBusiness?.name}</p>
                <p><strong>{tCommon('summaryNumPerson')}</strong><br />{dataBusiness.numUsers.name}</p>
              </Grid>

              <Grid item xs={12} className='summaryView-message'>
                <p>{tCommon('summaryExtraDetails')}</p>
              </Grid>
            </> :
            <>
              <Grid item xs={12}>
                <HeaderHLPure title={tCommon('titleSummary')} />
              </Grid>

              <Grid item xs={12} md={6}>
                <p><strong>{tCommon('summaryName')}</strong><br />{user?.firstName} {user?.firstLastName} {user?.secondLastName}</p>
              </Grid>

              <Grid item xs={12} md={6}>
                <p><strong>{tCommon('summaryContact')}</strong><br />{user?.email}</p>
              </Grid>

              {
                user?.phoneNumber && <Grid item xs={12}>
                  <p><strong>{tCommon('phoneNumber')}</strong><br />{user?.phoneNumber}</p>
                </Grid>
              }

              <Grid item xs={12} className='summaryView-message'>
                <p>{tCommon('summaryRegularUserPart1')}</p>
                <p>{tCommon('summaryRegularUserPart2')}</p>
              </Grid>
            </>

        }

        <Grid item xs={12} className='onboardingView-actions'>
          <ButtonHLPure colorScheme="primary" nameBtn={tCommon("finishButton")} onClick={onSubmitStep} />
        </Grid>
      </Grid>
    </>
  )
}

export default SummaryView